module.exports = __webpack_public_path__ + "assets/img/onekonggou.92dbada9.jpg";